import { Component, Input } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { AuthenticatorService } from '@aws-amplify/ui-angular';

import { environment } from '@environments/environment';

import packageJson from '../../../../../package.json';
import { NewsletterDialogComponent } from './components/newsletter-dialog/newsletter-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() showMenuInFooter = false;
  protected contactComponentVisible: boolean = false;
  blogEnabled: boolean = environment.blogFeatureEnabled;
  documentsStorageUrl = environment.documentsStorageUrl;

  version = packageJson.version;

  constructor(
    public readonly authenticator: AuthenticatorService,
    public newsletterDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.router.events.subscribe((events) => {
      if (events instanceof NavigationEnd) {
        this.contactComponentVisible = events.url.includes('contact');
      }
    });
  }

  public openNewsletterDialog(): boolean {
    this.newsletterDialog.open(NewsletterDialogComponent);
    return false;
  }
}
